<template>
  <ChartLine :data="chartData" :options="options" />
</template>

<script>
import { Line as ChartLine } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
)

export default {
  name: 'LineChart',
  components: { ChartLine },
  props: ['datasets', 'labels', 'options'],

  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      }
    },
  },
};
</script>
